import englishTranslations from './englishTranslations';
import spanishTranslations from './spanishTranslations';
var translations = {
    en: englishTranslations,
    es: spanishTranslations
};
export default translations;
//# sourceMappingURL=translations.js.map